/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineLite
} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";

export class SpinStop implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }


    public getAnimation(data:ParsedServerData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>{
            HarlequinGameModuleConfig.nearWinView.reset();
        });
        return tl;
    }

    public abort(isActive:boolean, data:ParsedServerData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>{
            HarlequinGameModuleConfig.nearWinView.reset();
        }, this.stagger);
        return tl;
    }

}